import * as React from 'react'
declare const I18n: any

import CategoryCard from '../../components/card_item/category_card'
import Header from '../../../Header'
import BreadCrumb from '../../../BreadCrumb'
import api from '../../../../api'

type ResourceCategory = {
  id: number
  name: string
  resource_type: string
  cover_image_url?: string | null
  description?: string
  language?: 'en' | 'fr'
}

type Props = {
  categories: ResourceCategory[]
  selectedLanguage?: 'en' | 'fr' | null
}

const AllResourceCategory: React.FC<Props> = ({ categories, selectedLanguage = null }) => {
  const [languageFilter, setLanguageFilter] = React.useState<'en' | 'fr' | null>(selectedLanguage)

  const handleDelete = (id: number): void => {
    api
      .deleteResourceCategory(id)
      .then(() => window.location.reload())
      .catch((error) => console.error('Error', error))
  }

  const filteredCategories = React.useMemo(
    () => (languageFilter ? categories.filter((c) => c.language === languageFilter) : categories),
    [categories, languageFilter]
  )

  return (
    <div className="resource_categories_index">
      <Header
        title={I18n.t('models.resource_category.attributes.category')}
        titleButton={I18n.t('models.resource_category.messaging.create')}
        locationButton="/admin/explore_categories/new"
      />

      <BreadCrumb
        locations={[
          {
            title: I18n.t('models.resource_category.messaging.explore_resources'),
            url: "/admin/explore_categories",
          },
          {
            title: I18n.t('models.resource_category.attributes.categories'),
            url: null,
          },
        ]}
      />

      <div className="mb-3">
        <button
          type="button"
          className={`btn btn-sm mr-2 ${languageFilter === null ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => setLanguageFilter(null)}
        >
          All
        </button>
        <button
          type="button"
          className={`btn btn-sm mr-2 ${languageFilter === 'en' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => setLanguageFilter('en')}
        >
          EN
        </button>
        <button
          type="button"
          className={`btn btn-sm ${languageFilter === 'fr' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => setLanguageFilter('fr')}
        >
          FR
        </button>
      </div>

      <div className="courses_index__list">
        {filteredCategories.length > 0 ? (
          <>
            {filteredCategories.map((row, index) => (
              <CategoryCard
                key={row.id}
                cardBackground="primary"
                title={row.name}
                description={row.description || ''}
                targetRole="all"
                id={row.id}
                index={index}
                image={row.cover_image_url ?? null}
                handleDelete={handleDelete}
              />
            ))}
          </>
        ) : (
          <div className="courses_index__empty-state app-text">
            {I18n.t('models.resource_category.messaging.empty_state')}
          </div>
        )}
      </div>
    </div>
  )
}

export default AllResourceCategory
